module.exports = __webpack_public_path__ + "media/andenes/electrico-a866c8da.webp";